import React from 'react';
import Header, { LandingHeaderLinks } from '../../components/header/header';
import Footer from '../../components/footer/footer';
// Shares the corporate layout and type scale with the landing page.
import '../landing/landing.scss';

function About() {
  // index.html carries the landing page's title and canonical for every path,
  // since one file is served for the whole site.
  React.useEffect(() => {
    document.title = 'About — Gotok Technologies Limited';
    const canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) canonical.setAttribute('href', 'https://gotok.app/about');
    return () => {
      document.title =
        'Gotok Technologies Limited — Simple tools for everyday people';
      if (canonical) canonical.setAttribute('href', 'https://gotok.app/');
    };
  }, []);

  return (
    <main className="c-corp">
      <Header>
        <LandingHeaderLinks />
      </Header>

      <section className="c-corp__hero">
        <div className="l-wrapper">
          <h1>Gotok Technologies Limited</h1>
          <p className="c-corp__sub">
            An independent software company building simple tools for everyday
            people.
          </p>
        </div>
      </section>

      <section className="c-corp__prose" id="company">
        <div className="l-wrapper">
          <p className="c-corp__eyebrow">Company</p>
          <p>
            We build and operate our own consumer products end to end — design,
            engineering, support, and marketing — rather than doing contract or
            agency work for other companies. Peckle, an AI photo studio for
            people who sell things, is our first product.
          </p>
          <p>
            Our customers are small and micro sellers who market their own
            inventory without a designer or a marketing budget: market traders,
            thrift and fashion resellers, bakers, jewellery makers, salons, and
            small independent shops. We are active in Nigeria, India, Brazil,
            and the United States, and our products are localised into nine
            languages.
          </p>
        </div>
      </section>

      <section className="c-corp__prose" id="business-model">
        <div className="l-wrapper">
          <p className="c-corp__eyebrow">How we make money</p>
          <p>
            Our products are free to start and earn revenue from optional paid
            upgrades — recurring subscriptions that unlock higher-quality output
            and higher usage limits, plus one-off credit packs for people who
            prefer not to subscribe. Purchases are processed by the Apple App
            Store and Google Play on mobile, and by our payment processor on the
            web. Prices are set per market rather than converted at checkout.
          </p>
          <p>
            We sell software directly to the people who use it. We do not sell
            advertising, resell platform access, or provide marketing services
            to third parties.
          </p>
        </div>
      </section>

      <section className="c-corp__prose" id="advertising">
        <div className="l-wrapper">
          <p className="c-corp__eyebrow">Advertising &amp; platform APIs</p>
          <p>
            Gotok markets its own products directly. We run app-install and
            web-traffic campaigns for Peckle on advertising platforms including
            Google Ads and Meta, paid for by Gotok and promoting only products
            we own.
          </p>
          <p>
            Because we advertise in several countries and languages at once, we
            maintain internal tooling that generates localised ad creatives from
            a shared configuration, creates and updates campaigns, manages
            budgets, and reports performance back to our team. This tooling is
            used only by Gotok staff, operates only on advertising accounts that
            Gotok owns, and is not sold, licensed, or made available to anyone
            outside the company.
          </p>
          <p>
            <a
              className="c-corp__product-link"
              href="https://peckle.ai/about"
              target="_blank"
              rel="noreferrer"
            >
              More about Peckle <span aria-hidden="true">→</span>
            </a>
          </p>
        </div>
      </section>

      <section className="c-corp__contact">
        <div className="l-wrapper">
          <p className="c-corp__eyebrow">Contact</p>
          <a href="mailto:help@gotok.app">help@gotok.app</a>
        </div>
      </section>

      <Footer />
    </main>
  );
}

export default About;
